// `image.template`: a run of one of live's picture templates (G14). Started by its template's
// form on the Templates page, never a Studio draft; it lists there, in My Generations.
import { ImageTemplateQuote, ImageTemplateRequest } from "../../../api/generated/zod";
import type { JobTypeModule } from "./contract";

export const jobType: JobTypeModule<"image.template"> = {
  type: "image.template",
  label: "Template",
  source: "form",
  pair: "image.template",
  fields: () => ({}),
  request: ImageTemplateRequest,
  quote: ImageTemplateQuote,
};
